const StringConstants = {
  APP_NAME: 'payments-landlord-web',
  PAYMENTS_PAGE: 'Payments | Zillow Rental Manager',

  FORMATTED_BRAND_NAMES: {
    zillow: 'Zillow',
  },

  UNFORMATTED_BRAND_NAMES: {
    zillow: 'zillow',
  },

  LINKS: {
    SUPPORT_EMAIL: 'rentpayments@zillow.com',
    FAQ_PAGE: 'https://zillow.zendesk.com/hc/en-us/sections/360000067847-Online-Rent-Payments',
    PAYMENTS_MARKETING_PAGE: 'https://www.zillow.com/z/rental-manager/collect-rent-online/',
    FAST_PAYMENTS_HELP: 'https://www.zillow.help/article/What-are-Fast-Payments',
    TERMS_OF_USE: 'https://www.zillow.com/corp/Terms.htm',
    RENTAL_USER_TERMS: 'https://www.zillow.com/renter-hub/terms/Rental-User-Terms',
    STRIPE_PAYMENT_TERMS: 'https://stripe.com/us/connect-account/legal',
    PLAID_BANK_AUTHORIZATION_TERMS: 'https://plaid.com/legal',
    SUPPORT_PAGE_LANDLORD: 'https://zgrentals.zendesk.com/hc/en-us/requests/new?ticket_form_id=360000053487',
    TAX_VERIFICATION_LEARN_MORE: 'https://www.irs.gov/businesses/understanding-your-form-1099-k',
  },
} as const;

export default StringConstants;
